import React from 'react';
import Localize from 'react-intl-universal';

import HomeIcon from '@mui/icons-material/Home';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { isFraunhofer } from '@common/Util';
import StyledBoxCenter from '@components/StyledBoxCenter/StyledBoxCenter';
import StyledConfirmTypography from '@components/StyledConfirmTypography/StyledConfirmTypography';
import StyledErrorIcon from '@components/StyledErrorIcon/StyledErrorIcon';
import StyledEventAvailableIcon from '@components/StyledEventAvailableIcon/StyledEventAvailableIcon';
import StyledGoHomeButton from '@components/StyledGoHomeButton/StyledGoHomeButton';
import { useGlobalContext } from '@hooks/Context/GlobalContext';

export default function ConfirmationPage({
  confirmMessage,
  errorMessage,
  approvalNeeded,
  headline1,
  headline2,
  headline3,
  isLoading
}) {
  const [contextData] = useGlobalContext();
  return (
    <StyledBoxCenter component='main'>
      {confirmMessage && (
        <Box>
          <StyledEventAvailableIcon />
          {headline1 && <StyledConfirmTypography>{headline1}</StyledConfirmTypography>}
          {headline2 && <StyledConfirmTypography>{headline2}</StyledConfirmTypography>}
          {!approvalNeeded && <Typography sx={{ fontSize: '1.3rem' }}>{confirmMessage}</Typography>}
        </Box>
      )}

      {errorMessage && headline3 && (
        <Box>
          <StyledErrorIcon />
          <StyledConfirmTypography>{headline3}</StyledConfirmTypography>
        </Box>
      )}
      {contextData?.isCatalogVisible && !isLoading && !isFraunhofer() && (
        <StyledGoHomeButton href='/' variant='contained' startIcon={<HomeIcon />}>
          {Localize.get('NotFound.goToHomePage')}
        </StyledGoHomeButton>
      )}

      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </StyledBoxCenter>
  );
}
